(function () {
    function debounce(fn, wait) {
        let t;
        return function (...args) {
            window.clearTimeout(t);
            t = window.setTimeout(() => fn.apply(this, args), wait);
        };
    }

    function init_logo_marquee(viewport) {
        const track = viewport.querySelector('.block-list-track');
        const original_list = viewport.querySelector('[data-marquee-list]');

        if (!viewport || !track || !original_list) {
            return;
        }

        function remove_clones() {
            const clones = track.querySelectorAll('ul[data-marquee-clone="true"]');
            clones.forEach((clone) => clone.remove());
        }

        function set_scrolling_state(is_scrolling) {
            viewport.classList.toggle('is-scrolling', is_scrolling);
        }

        function set_speed_vars(list_width) {
            const computed = window.getComputedStyle(viewport);

            const speed_raw = computed.getPropertyValue('--marquee-speed');
            const speed = parseFloat(speed_raw) || 80;

            viewport.style.setProperty('--marquee-shift', `${list_width}px`);
            viewport.style.setProperty('--marquee-duration', `${(list_width / speed).toFixed(3)}s`);
        }

        function build() {
            remove_clones();

            const reduce_motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (reduce_motion) {
                set_scrolling_state(false);
                return;
            }

            const viewport_width = viewport.clientWidth;

            const prev_animation = track.style.animation;
            track.style.animation = 'none';

            const list_width = original_list.scrollWidth;

            // Keep speed constant regardless of list length:
            // duration = distance(px) / speed(px per second)
            set_speed_vars(list_width);

            track.style.animation = prev_animation;

            if (list_width <= viewport_width) {
                set_scrolling_state(false);
                return;
            }

            set_scrolling_state(true);

            const min_track_width = Math.max(list_width * 2, viewport_width * 2);
            let current_width = list_width;

            while (current_width < min_track_width) {
                const clone = original_list.cloneNode(true);
                clone.setAttribute('aria-hidden', 'true');
                clone.setAttribute('data-marquee-clone', 'true');

                track.appendChild(clone);
                current_width += list_width;
            }
        }

        const rebuild = debounce(build, 150);

        window.addEventListener('resize', rebuild, { passive: true });

        // Rebuild after images load (important for accurate widths)
        const imgs = original_list.querySelectorAll('img');
        imgs.forEach((img) => {
            if (!img.complete) {
                img.addEventListener('load', rebuild, { passive: true });
                img.addEventListener('error', rebuild, { passive: true });
            }
        });

        build();
        requestAnimationFrame(build);
    }

    function init_all() {
        const marquees = document.querySelectorAll('[data-marquee]');
        marquees.forEach(init_logo_marquee);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init_all);
    } else {
        init_all();
    }
})();
